/** @jsxImportSource solid-js */
import { createSelectInput } from "#palette/components/form/select.solid";
import { SubmitButton } from "#palette/components/form/submit.solid";

// TODO: fetch these from the list of partners
const institutionOptions = [
  {
    id: "uscollege",
    display: "Yes, I am affiliated with a U.S. College or University.",
  },
  {
    id: "eduemail",
    display: "Not currently, but I have access to a .edu email.",
  },
  {
    id: "[unknown]",
    display: "No, I am not affiliated with a U.S. College or University.",
  },
];

/**
 * Show a page for users to select their institution.
 */
export function Step_1_Institution(props: {
  goUnknown: () => void;
  goNext: () => void;
}) {
  const institutionChoice = createSelectInput({
    items: institutionOptions,
  });

  function checkAvailability() {
    if (institutionChoice.selected() === institutionOptions.length - 1) {
      props.goUnknown();
      return;
    }

    props.goNext();
  }

  return (
    <>
      <p class="mt-2 mb-2">
        Callisto Vault is the first of its kind encrypted platform, where
        survivors of sexual violence can create a secure and timestamped record
        of an assault and/or safely find out if their perpetrator has harmed
        someone else.
      </p>

      <p class="mt-2 mb-2">
        While we are so sorry for what you’ve been through, we are so glad
        you’re here.
      </p>

      <p class="mt-2 mb-2">
        Setting up your secure account is easy, and we'll walk you through the
        steps.
      </p>
      <h1 class="mb-3 mt-6 text-xl font-medium  text-brand-900 font-serif">
        First, are you affiliated with a US College or University?
      </h1>
      {institutionChoice.component}
      <SubmitButton
        onClick={checkAvailability}
        disabled={institutionChoice.selected() === -1}
        title={"Verify"}
      />
    </>
  );
}
